import { SHIP_FROM_ADDRESSES_ACTIONS } from './shipFromAddresses.types'

/**
 * @param {Object.<string, import('./shipFromAddresses.types').ShipFromAddress>} payload
 * @returns {Object}
 */
export const setShipFromAddressesAction = payload => ({
  type: SHIP_FROM_ADDRESSES_ACTIONS.SET_SHIP_FROM_ADDRESSES,
  payload
})

/**
 * @param {import('./shipFromAddresses.types').ShipFromAddress} payload
 * @returns {Object}
 */
export const setShipFromAddressAction = payload => ({
  type: SHIP_FROM_ADDRESSES_ACTIONS.SET_SHIP_FROM_ADDRESS,
  payload
})

/**
 * @param {import('../slice.types').SliceStatus} payload
 * @returns {Object}
 */
export const setShipFromAddressesStatusAction = payload => ({
  type: SHIP_FROM_ADDRESSES_ACTIONS.SET_STATUS,
  payload
})

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {Object}
 */
export const setShipFromAddressesErrorsAction = payload => ({
  type: SHIP_FROM_ADDRESSES_ACTIONS.SET_ERRORS,
  payload
})

/**
 * @returns {Object}
 */
export const clearShipFromAddressesErrorsAction = () => ({
  type: SHIP_FROM_ADDRESSES_ACTIONS.CLEAR_ERRORS
})
